<div>

	<label class="input-wallet-address-label">
		<input
			type="text"
			id="inputWalletAddress"
			bind:value={inputWalletAddress}
			placeholder={inputPlaceHolder}
			>
		
		<div>
			<small style="line-height: 2;">
				▼　get transaction history ▼
			</small>
		</div>
		<button on:click={()=>{accessWallet("bsc")}}>
			<img src="/binance_logo.svg" alt="BSC">
			BSC
		</button>
		<button on:click={()=>{accessWallet("eth")}}>
			<img src="/eth_diamond_rainbow_logo.svg" alt="ETH">
			ETH
		</button>
		<button on:click={()=>{accessWallet("pol")}}>
			<span>🔗</span>
			<!-- <img src="/eth_diamond_rainbow_logo.svg" alt="POLYGON"> -->
			POLYGON
		</button>

		<!-- OpenSea v1 API廃止 (HTTP 410) のため一時非表示。差し替え時にこのifを外す -->
		{#if false}
			<div>
				<small style="line-height: 2;">
					▼　NFTs ( Now Only Loot(for Adventurers) ) ▼
				</small>
			</div>
			<button style="visibility: hidden;"></button><!--仮-->
			<button on:click={()=>{getCollectionFromOpensea()}}>
				<img src="/opensea_logo.svg" alt="OPENSEA">
				OPENSEA
			</button>
			<button style="visibility: hidden;"></button><!--仮-->
			{#if nftCollection.length > 0 }
				<div>	
					{#each nftCollection as nft}
						<div style="display: flex; justify-content: space-between; flex-wrap: wrap; padding: 20px 0;">
							{#each Object.entries(nft) as [key, value]}
								<!-- <pre style="display: none;"> -->
											<!-- <pre>
												<span>{JSON.stringify(key)}</span> /
												<span>{JSON.stringify(value)}</span>
											</pre> -->
								{#if key === 'permalink' }
									<a style="padding: 10px;" target="_blank" href={value}>buy</a>
								{/if}
								{#if key === 'token_metadata' }
									<!-- // 29 = length of "data:application/json;base64," 	 -->
									<img style="width: 300px;" alt="img" src="{ JSON.parse( atob( value.substring(29) ) ).image }">
								{/if}
								{#if key === 'traits' }
									<ul style="width: 200px; padding: 10px; text-align: left; margin: 0;">
										{#each value as obj}
											<li style="margin-bottom: 7.5px; line-height: 1;">
												<small>
													{obj.value}
												</small>
												<a style="color: #555;" target="_blank" href="https://audius.co/search/{obj.value}">
													<img style="width: 20px; height: 20px; object-fit: cover;" src="/audius_logo.png" alt="audius_logo">
												</a>
												<a style="color: #555;" target="_blank" href="https://soundcloud.com/search?q={obj.value}">
													<img style="width: 20px; height: 20px; object-fit: cover;" src="/soundcloud_logo.png" alt="soundcloud_logo">
												</a>
											</li>
										{/each}
									</ul>
								{/if}
							{/each}
						</div>
						<hr>
					{/each}
				</div>
			{/if}
		{/if}

	</label>

	<Example/>

	{#if error !== "" }
		<p>{error}</p>	
	{/if}

</div>

<script>
	import { onMount } from "svelte";	
	import { createEventDispatcher } from 'svelte';
	import Example from "./Example.svelte";

	const d = document;
	const dispatch = createEventDispatcher();

	// 渡されてきたやつら
	export let inputWalletAddress;
	export let transactionHistories;
	let error            = "";
	let inputPlaceHolder = "";
	let nftCollection    = [];
	
	// placeholderアニメーション用
	onMount(()=>{
		const placeHolder = "👛 input ( your ) BSC / ETH wallet address";
		let fixedPlaceHolder = "";
		for(let i=0;i<placeHolder.length;i++){
			setTimeout(()=>{
				fixedPlaceHolder += `${placeHolder[i]}`;
				inputPlaceHolder = fixedPlaceHolder;
			}, i*75);
		}
	});
	// localStorage読み出し用
	onMount(()=>{
		applyStoredInputWalletAddress();
	});
	

	// ---------------------
	// localStorage書込|読出
	function storeInputWalletAddress(address){
		localStorage.setItem("storedInputWalletAddress", address);
	}
	function applyStoredInputWalletAddress(){
		if(localStorage.getItem("storedInputWalletAddress")){
			inputWalletAddress = localStorage.getItem("storedInputWalletAddress");
		}
	}
	// ----------------------

	function checkWalletAddressCollect(address){
		const web3 = new Web3( 'https://bsc-dataseed1.binance.org:443' );
		return web3.utils.isAddress(address);
	}
	async function getTransactionHistory(chain,address) {
		const baseUrl = 'https://minehash.xoun.deno.net';
		const url = `${baseUrl}/${chain}/${address}`;
		return fetch(url).then( res => {
			return res.json();
		});
	}

	function accessWallet(chain){

		const address = inputWalletAddress;
		error = "";

		if( checkWalletAddressCollect(address) ){

			storeInputWalletAddress(address);

			( async ()=>{
				const jsonArr = await getTransactionHistory(chain,address);
				
				// transaction 全くなくても result自体は返る     
				// console.log(jsonArr);                
				if( Array.isArray(jsonArr.result) ) {
					transactionHistories = jsonArr.result;
					dispatch('checkAddress', { inputWalletAddress,transactionHistories });
				} else {
					error = `invalid`;
				}
			})();
		} else {
			error = `invalid address`;
		}
	}

	function getCollectionFromOpensea(){
		const address = inputWalletAddress;
		const contract = '0xff9c1b15b16263c61d017ee9f65c50e4ae0113d7'; // 現在 Loot のみ
		const contracts = [];
		error = "";
		if( checkWalletAddressCollect(address) ){
			storeInputWalletAddress(address);
			( async ()=>{
				const options = {
					method: 'GET'
				};
				fetch(`https://api.opensea.io/api/v1/assets?owner=${address}&asset_contract_address=${contract}&order_direction=desc&offset=0&limit=20`,options)
					.then(res => res.json())
					.then(res=>{
						if(res.assets){
							nftCollection = res.assets;
							// console.log(nftCollection);
						}
					})
					.catch(err => console.error(err));
			})();
		} else {
			error = `invalid address`;
		}
	}
</script>

<style lang="scss">
	.input-wallet-address-label {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		max-width: 600px;
		margin: 0 auto;

		& > input {
			width: 100%;
			background-color: #fff;
			text-align: center;	

			&::placeholder {
				color: #999;
			}
		}

		& > div {
			width: 100%;
		}

		& > button {
			width: 33.333%;
			border: 3px double #ccc;
			font-weight: 600;
			cursor: pointer;

			& > img {
				width: 18px;
				height: 18px;
			}

			& > span {
				// polygon絵文字用
				width: 20px;
				height: 20px;
				display: inline-block;
				vertical-align: bottom;
				padding: 2px 0 1px;
				transform: rotateX(180deg);
			}

			&:hover {
				background-color: #fff;
			}
		}
	}
	@media (max-width: 480px) {
		.input-wallet-address-label {
			display: block;

			& > input {
				width: 100%;
			}

			& > button {
				width: 32%;
				display: inline-block;
				letter-spacing: -.25vw;
				font-size: 3.5vw;
			}
		}
	}
</style>
